import React, { useEffect } from 'react';
import '../styles/Gstservice.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaFileInvoice, FaUserTie, FaWpforms, FaHandsHelping, FaMoneyCheckAlt } from 'react-icons/fa';

import image1 from '../assets/gst7.png'; // Replace with GST registration image
import image2 from '../assets/gst2.jpg'; // Replace with expert guidance image
import image3 from '../assets/gst13.jpg'; // Replace with gst filing image
import image4 from '../assets/gst3.webp'; // Replace with support image
import image5 from '../assets/gst5.jpg'; // Replace with affordability image
import parallaxImg from '../assets/gs2.jpg';

const Gstservice = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="webservice-container">
      {/* 1. GST Registration */}
      <div className="webservice-section">
        <div className="webservice-box" data-aos="fade-right">
          <FaFileInvoice className="webservice-icon" />
          <h3>GST Registration</h3>
          <p>Get your business GST-compliant with our fast and hassle-free registration service. Whether you're a startup, SME, or an established enterprise, we handle the entire process—from document collection and application submission to final registration—ensuring accuracy and compliance. Our experts stay updated with the latest regulations to provide a smooth experience and help you avoid penalties. With us, your GST registration is in safe, professional hands.</p>
        </div>
        <div className="webservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image1})` }} />
      </div>

      {/* 2. Expert Guidance */}
      <div className="webservice-section">
        <div className="webservice-image" data-aos="fade-right" style={{ backgroundImage: `url(${image2})` }} />
        <div className="webservice-box" data-aos="fade-left">
          <FaUserTie className="webservice-icon" />
          <h3>Expert Guidance</h3>
          <p>Navigating tax laws and GST compliance can be complex—but you don’t have to do it alone. Our seasoned GST consultants offer personalized guidance tailored to your business needs. From understanding eligibility and filing requirements to resolving notices and audits, we simplify every step with clear, reliable advice. With our expertise by your side, you can focus on growing your business while staying fully compliant.</p>
        </div>
      </div>

      {/* 3. GST Filing */}
      <div className="webservice-section">
        <div className="webservice-box" data-aos="fade-right">
          <FaWpforms className="webservice-icon" />
          <h3>GST Filing</h3>
          <p>Timely and accurate GST filing is crucial to avoid penalties and maintain seamless business operations. Our team ensures that all your monthly, quarterly, and annual GST returns are filed correctly and on time. We handle everything—from data reconciliation to error checks—so you can stay stress-free and compliant. With our efficient filing services, you gain peace of mind and more time to focus on your core business.</p>
        </div>
        <div className="webservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image3})` }} />
      </div>

      {/* 4. End-to-End Support */}
      <div className="webservice-section">
        <div className="webservice-image" data-aos="fade-right" style={{ backgroundImage: `url(${image4})` }} />
        <div className="webservice-box" data-aos="fade-left">
          <FaHandsHelping className="webservice-icon" />
          <h3>End-to-End Support</h3>
          <p>We provide comprehensive, end-to-end support throughout your GST journey—from registration and documentation to return filing and compliance management. Our experts stay with you at every stage, offering real-time assistance, resolving queries, and ensuring all your GST-related obligations are handled smoothly. With our full-spectrum support, you can focus on growing your business while we take care of the complexities.</p>
        </div>
      </div>

      {/* 5. Affordable Pricing */}
      <div className="webservice-section">
        <div className="webservice-box" data-aos="fade-right">
          <FaMoneyCheckAlt className="webservice-icon" />
          <h3>Affordable Pricing</h3>
          <p>Our GST services are designed to deliver exceptional value without compromising quality. We offer transparent, competitive pricing tailored to meet the needs of businesses of all sizes. With no hidden fees and flexible packages, you can access expert GST registration, filing, and support services that fit your budget—helping you save money while staying fully compliant.</p>
        </div>
        <div className="webservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image5})` }} />
      </div>

      {/* Parallax Banner */}
      <div className="parallax-container">
        <div className="parallax-background" style={{ backgroundImage: `url(${parallaxImg})` }} />
        <div className="parallax-overlay">
          <h1 className="parallax-heading">GROW YOUR BUSINESS WITH GST COMPLIANCE</h1>
        </div>
      </div>
    </div>
  );
};

export default Gstservice;
